import { render } from "./CalculatorPage.vue?vue&type=template&id=66c62b72"
import script from "./CalculatorPage.vue?vue&type=script&lang=js"
export * from "./CalculatorPage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\ITLinked\\2022\\stat-calculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__